export default "__VITE_PUBLIC_ASSET__43b1a421__"